import React, { Component } from "react";
import { Row, Col, Button } from "reactstrap";
import { getServerEndpoint } from "./../../../utils/serverEndpoint";
import SvgIcon from "react-icons-kit";
import { plus } from "react-icons-kit/icomoon/plus";
import "./uploadbutton.css";
import noImage from "./../../../images/noImage.png";
import _ from "lodash";
import { FORM_MODES } from "../../../utils/globals";
import { themeService } from "theme/service/activeTheme.service";
import { basicColors, retroColors, electricColors } from "../../../style/basic/basicColors";
import { fetchStaticResource, sanitizedFilename } from "../../../utils/utils";

class MaintenanceImageArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainImageIndex: 0,
      imagesList: [],
    };
  }

  handleShowImageGallery = () => {
    this.props.addMaintenanceStateHandler({ formModes: FORM_MODES.IMAGE_SELECTION });
  };

  handleShowImageSlider = (selectedImageIndex) => {
    this.props.addMaintenanceStateHandler({
      formModes: FORM_MODES.IMAGE_GALLERY,
      selectedImageIndex,
    });
  };

  onClick(index) {
    //console.log('image gallery click:', imagename, index);
    // make clicked image as zero index
    this.setState({ mainImageIndex: index });
  }
  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(this.props.imagesList) !== JSON.stringify(prevProps.imagesList) && this.props.imagesList.length) {
      this.setState({ imagesList: _.cloneDeep(this.props.imagesList) });
    }
  }
  render() {
    let imagesList = null;
    // console.log(this.props.imagesList)
    if (this.props.imagesList) {
      imagesList = this.props.imagesList.map((imageName, index) => {
        if (index !== this.state.mainImageIndex) {
          return (
            <div style={{ display: "inline-block", width: "30%", margin: "0 3% 0 0", cursor: "pointer" }} key={imageName + index}>
              <ImageMainComp
                imageName={imageName}
                borderStyle={"1px solid var(--first)"}
                width={"100%"}
                height={"100%"}
                onClick={() => {
                  this.onClick(index);
                }}
              />
            </div>
          );
        }
      });
    }

    return (
      <div>
        <Row>
          <Col md={12}>
            <ImageMainComp
              imageName={this.props.imagesList[this.state.mainImageIndex]}
              onClick={() => {
                if (this.props.imagesList && this.props.imagesList.length > 0) this.handleShowImageSlider(this.state.mainImageIndex);
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col md={10}>
            <div
              className="scrollbarHor"
              style={{ overflow: "auto", whiteSpace: "nowrap", padding: "10px 0px 5px 0px", minHeight: "110px" }}
            >
              {imagesList}
            </div>
          </Col>
          <Col md={2} style={{ padding: "0px" }}>
            <div
              style={themeService({
                default: { padding: "25px 0px", margin: "auto", width: "50%", color: "var(--first)" },
                retro: { padding: "25px 0px", margin: "auto", width: "50%", color: "var(--second)" },
                electric: { padding: "25px 0px", margin: "auto", width: "50%", color: electricColors.second },
              })}
            >
              {/* <div className="upload-btn-wrapper">
                <SvgIcon icon={plus} size={20} />

                <input type="file" name="myfile" accept="image/*" onChange={this.props.addImage} />
              </div> */}
              <span style={{ cursor: "pointer" }}>
                <SvgIcon icon={plus} size={20} onClick={() => this.handleShowImageGallery(true)} />
              </span>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default MaintenanceImageArea;

class ImageMainComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageSrc: noImage, // Default to placeholder image
    };
  }

  componentDidMount() {
    this.loadImage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.imageName !== this.props.imageName) {
      this.loadImage();
    }
  }

  async loadImage() {
    if (!this.props.imageName) {
      this.setState({ imageSrc: noImage });
      return;
    }
    const currentImageName = this.props.imageName; // Capture current prop
    try {
      let path = getServerEndpoint() + "applicationresources/" + sanitizedFilename(this.props.imageName);
      const imageToDisplay = await fetchStaticResource(path);
      // Only update state if the prop hasn't changed since the fetch started
      if (currentImageName === this.props.imageName) {
        this.setState({ imageSrc: imageToDisplay });
      }
    } catch (error) {
      console.error("Error loading image:", error);
      this.setState({ imageSrc: noImage });
    }
  }

  render() {
    return (
      <div style={{ width: this.props.width ? "100%" : "100%" }}>
        <img
          style={{
            width: this.props.width ? "inherit" : "100%",
            height: this.props.height ? "inherit" : "220px",
            objectFit: "contain",
            border: themeService({
              default: { ...(this.props.borderStyle ? this.props.borderStyle : "3px solid var(--first)") },
              retro: {},
              electric: {},
            }),
            borderRadius: "5px",
          }}
          src={this.state.imageSrc}
          alt="img"
          onClick={this.props.onClick}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Maintenance/AddMaintenance/MaintenanceImageArea.jsx